// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__Wns15","inputDescription":"styles_inputDescription__aGfwy"};